import React from "react";
import PropTypes from "prop-types";
import ReactModal from "react-modal";
import CloseIcon from "../Icons/CloseIcon";

import styles from "./modal.module.scss";

function Modal(props) {
  return (
    <ReactModal
      className={styles.root}
      overlayClassName={styles.overlay}
      bodyOpenClassName={styles.body}
      {...props}
    >
      {props.children}
      <button className={styles.close} onClick={props.onRequestClose}>
        <CloseIcon />
      </button>
    </ReactModal>
  );
}

ReactModal.setAppElement(`body`);

Modal.propTypes = {
  children: PropTypes.element,
  onRequestClose: PropTypes.func
};

export default Modal;
